import React, { useState, useContext } from "react";
import "../../component/css/change_number.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import { TokenContext } from "../../component/token_context";

export default function Change_Name() {
  const navigate = useNavigate();
  const token = JSON.parse(sessionStorage.getItem("userToken"));
  const [fullname, SetFullname] = useState(" ");
  const [disable, setDisable] = useState(false);
  const value = useContext(TokenContext);
  const { setFire } = value;

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setDisable(true);
      const response = await fetch(
        "https://serverpickload.wl.r.appspot.com/admin_profile/edit_profile",
        {
          method: "POST",

          body: JSON.stringify({
            token: token,
            fullname: fullname,
          }),
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json, text/plain, */*",
          },
        }
      );
      if (response.status === 200) {
        //console.log('Phone number set successfully');
        setDisable(false);
        setFire(true);
        navigate("/App/Changed_Fullname_Successfully");
      } else {
        setDisable(false);
        //console.log('some error occurred');
      }
    } catch (e) {
      //console.log(e);
      setDisable(false);
    }
  };

  return (
    <div className="change-password">
      <div className="change-password-props">
        <div className="back2">
          <FontAwesomeIcon
            icon={faArrowLeftLong}
            onClick={() => navigate(-1)}
            className="back"
          ></FontAwesomeIcon>
        </div>
        <div className="change-password-style">Change Full Name</div>
        <form className="name-form" onSubmit={handleSubmit}>
          <div className="existing-password">
            <div>
              <label className="new-no">New Name</label>
              <div className="new-password-main">
                <input
                  type="text"
                  name="text"
                  className="new-phone-password"
                  placeholder="Enter New name"
                  value={fullname}
                  onChange={(e) => SetFullname(e.target.value)}
                />
              </div>
            </div>
          </div>
          <button className="save-changes1" disabled={disable}>
            {disable ? (
              <ClipLoader color={"black"} loading={disable} size={15} />
            ) : (
              "Save and Update"
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
